import React from "react";
Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

export const getJson = (arr, obj, value = 0) => {
    return arr.reduce((a, b) => a && a[b] ? a[b] : value, obj)
}

export const getNumber = (arr, obj, value = 0) => {
    return Number(arr.reduce((a, b) => a && a[b] ? a[b] : value, obj) || '0')
}

export function numConvert(num = 0, fixed = false) {
    num = Number(num || "0")
    if (fixed !== false) return num.toFixed(fixed)
    return num
};

// 除法
export function calculation(molecule = 0, denominator = 0, decimal = 2) {
    if (denominator == 0 || molecule == 0 || !denominator || !denominator) {
        return 0
    }
    return (molecule / denominator).toFixed(decimal);
}

// 和
export function sum(data = [], decimal = 2) {
    return data.reduce((a, b) => {
        a += numConvert(b);
        return a
    }, 0).toFixed(decimal);
}

// 金额格式
export function moneyNumber(text) {
    return Number(text || '0') < 0 ?
        <span style={{ color: "red" }}>
            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
        </span>
        :
        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function isArray(o) {
    return Object.prototype.toString.call(o) == '[object Array]';
}

// 拉取权限内的菜单
export function getDeepMenu(auth, authData, data = []) {
    authData.forEach((item, index) => {
        if (item.children.length > 0 && item.children[0].title == '查看' && auth.includes(item.children[0].key)) {
            data.push(item);
        } else if (item.children.length > 0 && item.children[0].title != '查看') {
            let child = getDeepMenu(auth, item.children, child);
            data.push({
                ...item,
                children: child
            });
        }
    })

    return data
}

export default getJson;
export const Num = numConvert;

export const delay = (time = 1000) => {
    return new Promise(resolve => setTimeout(resolve, time));
}


// WEBPACK FOOTER //
// ./src/method/index.js